
export function selectMultipleHierarchical() {
  return {
    restrict: 'E',
    template: require('./select-multiple-hierarchical.directive.html'),
    scope: {
      model: '=',
      items: '=', // [{label: 'facebook', subitems: [{id: 1, label: 'public'}, {id: 2, label: 'private'}]}]
      optional: '<?',
      label: '<?',
      placeholder: '@?',
      readonly: '<?',
      readonlyJoinLabel: '@?',
      localStorageKey: '<?',
      onChangeFn: '&?onChange',
      onCloseFn: '&?onClose',
    },
    controller: controller
  };
}

controller.$inject = ['$element', '$scope', 'LocalStorageFactory'];
function controller($element, $scope, LocalStorageFactory) {

  $scope.isCategoryChecked = isCategoryChecked;
  $scope.isCategoryIndeterminate = isCategoryIndeterminate;
  $scope.toggleAllInCategory = toggleAllInCategory;
  $scope.callOnChange = callOnChange;
  $scope.callOnClose = callOnClose;

  init();

  function loadFromLocalStorage() {
    if ($scope.localStorageKey) {
      let value = LocalStorageFactory.getItem($scope.localStorageKey);
      if (value !== null) {
        $scope.model = value;
      }
    }
  }

  function saveToLocalStorage() {
    if ($scope.localStorageKey) {
      LocalStorageFactory.setItem($scope.localStorageKey, $scope.model);
    }
  }

  function isCategoryChecked(item) {
    return _selectedSubitems(item, $scope.directiveModel.values).length === item.subitems.length;
  };

  function isCategoryIndeterminate(item) {
    const selectedSubitemsNr = _selectedSubitems(item, $scope.directiveModel.values).length;
    return selectedSubitemsNr > 0 && selectedSubitemsNr < item.subitems.length;
  };

  function callOnChange() {
    if ($scope.onChangeFn) {
      $scope.onChangeFn();
    }
  }

  function callOnClose() {
    if ($scope.onCloseFn) {
      $scope.onCloseFn();
    }
  }

  function toggleAllInCategory(item) {
    const model = $scope.directiveModel.values;
    if (isCategoryChecked(item)) {
      // If the category is currently checked, then all subitems of that category are currently checked.
      // Let's loop on the selected array to unselect them one by one
      for (let i = 0; i < model.length; /* i is incremented below */) {
        if (item.subitems.find(subitem => subitem.id === model[i])) {
          model.splice(i, 1);
        } else {
          i++; // only increment index here, as splice() shifts the remaining elements to the left
        }
      }
    } else {
      // Otherwise, not all subitems are selected; let's add the missing ones
      item.subitems.forEach(subitem => {
        if (!model.includes(subitem.id)) {
          model.push(subitem.id);
        }
      });
    }
    $element.find('md-select').controller('ngModel').$validate(); // https://docs.angularjs.org/api/ng/type/ngModel.NgModelController#$validate
    callOnChange();
  };

  function init() {
    if (!$scope.model || $scope.model.length === 0) {
      loadFromLocalStorage();

      // If still undefined initialize it as an empty array
      if (!$scope.model) {
        $scope.model = [];
      }
    }

    // Work around ng-ifs and ng-repeats creating child scopes 
    // (see e.g. https://stackoverflow.com/questions/18342917/angularjs-ng-model-doesnt-work-inside-ng-if )
    $scope.directiveModel = {
      'values': $scope.model
    };

    // But in addition we need to forward any new value up to our parent scope 
    // (angular watches $scope.model because we declared it with '=' in the directive definition)
    $scope.$watch("directiveModel.values", newValue => {
      $scope.model = newValue;
      saveToLocalStorage();
    }, true);
  }
}

function _selectedSubitems(item, model) {
  return item.subitems.filter(subitem => model.includes(subitem.id));
}
